import { render, staticRenderFns } from "./ACTWGIMN.vue?vue&type=template&id=01c0905c&scoped=true&"
import script from "./ACTWGIMN.vue?vue&type=script&lang=js&"
export * from "./ACTWGIMN.vue?vue&type=script&lang=js&"
import style0 from "./ACTWGIMN.vue?vue&type=style&index=0&id=01c0905c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0905c",
  null
  
)

export default component.exports